export default "__VITE_ASSET__CQAeLXXy__"